// extracted by mini-css-extract-plugin
module.exports = {"root":"label_root__2oqT9","label":"label_label__1dP7e","name":"label_name__2VkU7","alone":"label_alone__2w4DI"};